/**
 * Effective file-upload size limit for the customer dashboard.
 *
 * Uploads (`POST /api/v1/data-objects`) pass through several layers, each with its
 * own cap. The SMALLEST (binding) one is the k8s API ingress:
 *   - API ingress (nginx `proxy-body-size`): 50m  <-- binding
 *       helm/stratforth/values.yaml (`stratforth-api-ingress`), and the
 *       values-staging / values-production overlays.
 *   - Frontend nginx (`client_max_body_size`): 100m
 *       frontend/dashboard-app/nginx.default.conf
 *   - Data Object Service (Spring multipart): 200MB default (100MB strict)
 *       backend/data-object-service/.../application.yml
 *
 * The client had NO pre-flight size check, so oversized files were uploaded in full
 * and then rejected at the ingress with a raw 413 (whose nginx HTML body is swallowed
 * into a generic "Upload failed"). We now reject early against the binding limit and
 * give a size-specific message. Keep this in sync with the ingress annotation if it
 * ever changes.
 */
export const MAX_UPLOAD_BYTES = 50 * 1024 * 1024; // 50 MB (ingress proxy-body-size: 50m)

export const MAX_UPLOAD_LABEL = '50 MB';
